import React, { useState } from "react";
import { Link } from "react-router-dom";
import Logo from '../../assests/Images/Logo-Blue.svg'
import axiosInstance from "../../api/axiosInstance";
import API_ENDPOINTS from "../../api/endpoints";
import { toast, ToastContainer } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { ThreeDots } from 'react-loader-spinner';


export default function Signup() {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        name: '',
        username: '',
        email: '',
        password: ''
    });
    const [loading, setLoading] = useState(false);


    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    }


    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await axiosInstance.post(API_ENDPOINTS.SIGNUP, formData);
            toast.success("Account created successfully! Please log in.");
            setTimeout(() => {
                navigate('/');
            }, 2000);
        } catch (error) {
            console.error(error);
            const errorMessage = error.response?.data?.message || "An error occurred. Please try again.";
            toast.error(errorMessage);
            setFormData({
                name: '',
                username: '',
                email: '',
                password: ''
            });
        }finally{
            setLoading(false);
        }
    }

    return (
        <div className="min-h-screen bg-black text-white flex items-center justify-center p-4">
            {loading &&
                <ThreeDots
                    visible={true}
                    height="80"
                    width="80"
                    color="#1976d2"
                    radius="9"
                    ariaLabel="three-dots-loading"
                    wrapperStyle={{}}
                    wrapperClass="dots-loading additional-class"
                />
            }
            <ToastContainer />
            <div className="w-full max-w-md bg-background/50 backdrop-blur border border-border p-6 ">
                <div className="flex flex-col items-center mb-8">
                    <div className="w-20 h-20 rounded-full flex items-center justify-center">
                        <img src={Logo} alt="Holecards Logo" className="h-18 w-18" />
                    </div>
                    <h1 className="text-white text-2xl font-semibold">Create an Account</h1>
                    <p className="text-gray-400">Sign up to start tracking your poker games</p>
                </div>

                <form className="space-y-6" onSubmit={handleSubmit}>
                    <div>
                        <label htmlFor="name" className="block text-sm font-bold text-white mb-2">
                            Full Name
                        </label>
                        <input
                            type="text"
                            name="name"
                            required
                            placeholder="Enter your full name"
                            className="w-full px-4 py-2 bg-black text-white border border-border rounded-md placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500"
                            onChange={handleChange}
                        />
                    </div>

                    <div>
                        <label htmlFor="username" className="block text-sm font-bold text-white mb-2">
                            Username
                        </label>
                        <input
                            type="text"
                            name="username"
                            required
                            placeholder="Choose a username (no spaces) "
                            className="w-full px-4 py-2 bg-black text-white border border-border rounded-md placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500"
                            onChange={handleChange}
                        />
                    </div>
                    <div>
                        <label htmlFor="email" className="block text-sm font-bold text-white mb-2">
                            Email
                        </label>
                        <input
                            type="email"
                            name="email"
                            required
                            placeholder="Enter your email"
                            className="w-full px-4 py-2 bg-black text-white border border-border rounded-md placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500"
                            onChange={handleChange}
                        />
                    </div>

                    <div>
                        <label htmlFor="password" className="block text-sm font-bold text-white mb-2">
                            Password
                        </label>
                        <input
                            type="password"
                            id="password"
                            name="password"
                            required
                            placeholder="Enter your password"
                            className="w-full px-4 py-2 bg-black text-white border border-border rounded-md placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500"
                            onChange={handleChange}
                        />
                    </div>

                    <button
                        type="submit"
                        className="w-full bg-secondary  text-white py-2 rounded-md hover:opacity-75 transition-colors"
                    >
                        Create Account
                    </button>
                </form>

                <p className="text-center text-gray-400 text-sm mt-6">
                    Already have an account?{" "}
                    <Link to={'/'} className="text-blue-400 hover:underline">
                        Sign in
                    </Link>
                </p>
            </div>
        </div>
    );
}
